import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { Amplify } from 'aws-amplify';

import TestVariables from './variables/testVariables'

let vp = null;

if (process.env.REACT_APP_TEST === 'TRUE') {
  vp = new TestVariables();
}
else {
  vp = new TestVariables();
}

Amplify.configure({
  Auth: {
    Cognito: {
      userPoolId: vp.cognitoUserPoolId,
      userPoolClientId: vp.cognitoUserPoolClientId
    }
  }
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// // If you want to start measuring performance in your app, pass a function
// // to log results (for example: reportWebVitals(console.log))
// // or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
